// extracted by mini-css-extract-plugin
export var address = "address-module--address--mQRGZ";